export default (id, url, setProgress) => {
    window.open(url);
};
export const fileDownloadedHandler = (id, url) => {
    return true;
};
